module.exports = __webpack_public_path__ + "img/川芎.4486a893.jpg";